import ResolutionSelectionFixedValues from './ResolutionSelectionFixedValues'

export default ResolutionSelectionFixedValues
